import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';
import { CommonModule } from '@angular/common';
import { IconDirective } from '@coreui/icons-angular';
import {
    ContainerComponent,
    INavData,
    ShadowOnScrollDirective,
    SidebarBrandComponent,
    SidebarComponent,
    SidebarFooterComponent,
    SidebarHeaderComponent,
    SidebarNavComponent,
    SidebarToggleDirective,
    SidebarTogglerDirective
} from '@coreui/angular';
import { ColorModeService } from '@coreui/angular';
import { DefaultFooterComponent, DefaultHeaderComponent } from './';
import { getNavItems, navItems } from './_nav';
import { SharedModule } from './shared.module';
import { MyService } from 'src/app/services/myservice';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './default-layout.component.html',
    styleUrls: ['./default-layout.component.scss'],
    standalone: true,
    imports: [
        SidebarComponent,
        SidebarHeaderComponent,
        SidebarBrandComponent,
        RouterLink,
        IconDirective,
        NgScrollbar,
        SidebarNavComponent,
        SidebarFooterComponent,
        SidebarToggleDirective,
        SidebarTogglerDirective,
        DefaultHeaderComponent,
        ShadowOnScrollDirective,
        ContainerComponent,
        RouterOutlet,
        CommonModule,
        DefaultFooterComponent,
        SharedModule  // Import the SharedModule
    ]
})
export class DefaultLayoutComponent implements AfterViewInit {
    public currentTheme: string = 'light';
    onScrollbarUpdate($event: any) {
        // Implement scrollbar update logic if needed
    }

    @ViewChild('sidebar') sidebar!: ElementRef;


    @ViewChild('sidebarToggleBtn') sidebarToggleBtn!: ElementRef;

    ngAfterViewInit() {
        // Simulate a click event on the sidebar toggle button to fold the sidebar initially
        if (this.sidebarToggleBtn) {
            this.sidebarToggleBtn.nativeElement.click();
        }
    }
    public navItems: any = null;

    constructor(
        private colorModeService: ColorModeService,
        private authservice: AuthenticationService,

    ) {
        try {
            const username = authservice.gettUserName();
            console.log("navbar user name is " + username);
            this.navItems = getNavItems(username);
        } catch (Exception) {
            this.navItems = getNavItems('');
        }
    }


    ngOnInit(): void {

        const storedTheme = this.colorModeService.getStoredTheme('coreui-free-angular-admin-template-theme-default');
        if (storedTheme) {
            this.currentTheme = storedTheme;
        }



    }


}
